module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA2ElEQVRIS+2WPQrCQBCF30u0VLyE6BG011IEj2CR3EDFA8SfG9h4AwVJrLTXK4iX8K/TZCQgVkpYWLdxp9xh5s1+vOIRAMKpX2aCMRM0hFJM33QVhRdxsBUHg1ZvduRq0q04cW5PoqRL5NMeEZwS91FjNPYXEOn8Uuy9m1xyHfhn3Ri/HS/AjdHIEyO/e4lYQe20LVKLVJmANY0ysqwBizSLkHLfIlVGljXwB0jNhyjTMTEMvCqAnYkgDKDO1FVp+nYlH4igSUghy2kqfQGvJDYx78N2f354Am1Odu0g8zv8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/tick_icon_nor@2x.png
// module id = AMJY
// module chunks = 1